import type { BottomNavigationAction, BottomNavigationDrawerAction } from "@bonusx-global/bx-design-system";
import type { IEnrichRouteWithLinkHandler } from "./enrich-route-with-click-handler.interface";

export function enrichRouteWithClickHandler({
  route,
  callback,
}: IEnrichRouteWithLinkHandler): BottomNavigationDrawerAction | BottomNavigationAction {
  const updatedRoute = { ...route };

  updatedRoute.onClickRoute = callback;

  if (updatedRoute.subpaths) {
    updatedRoute.subpaths = updatedRoute.subpaths.map((subroute) =>
      enrichRouteWithClickHandler({ route: subroute, callback: callback })
    );
  }

  return updatedRoute;
}
